// extracted by mini-css-extract-plugin
module.exports = {"calculatorbtns":"PrevNextBtns_calculatorbtns__tEPlp"};